<template>
  <div class="d-flex">
    <div class="w-50">
      <form-component />
    </div>
  </div>
</template>

<script>
  import FormComponent from './profile-change-password-form';

  export default {
    components: {
      FormComponent
    }
  };
</script>

<style lang="scss" scoped>
  .password-description {
    font-size: 16px;
    line-height: 1.75;
  }
</style>
